import React, { useEffect, useState } from 'react';
import { transform } from 'typescript';
import { globals } from '../../misc/globals';
import { BaseConfig } from '../BaseConfig';
import { UIProperties } from '../UIProperties';

import './TalksActionsButtons.css'

const TalksActionsButtons = (props: UIProperties<TalksActionsButtonsConfig>) => {
	const [isOver, setIsOver] = useState(false);
	const [forceHighlight, setforceHighlight] = useState(false);
    if(props.parameters.onForceHighlight) {
        props.parameters.onForceHighlight((shouldForce: boolean) => {
            setforceHighlight(shouldForce);
        });
    }
    
	useEffect(() => {

	}, [isOver])

	return (
		<div className='modal-disable-select' style={{
			position: 'absolute',
			top: props.parameters.top,
			left: '50px',
			width: '570px'
		}}>
			<button tabIndex={props.parameters.isDisabled() ? -1 : 0} aria-label={props.parameters.text} className="pointer" style={{
				position: 'relative',
				background: 'transparent',
				pointerEvents: props.parameters.isDisabled() ? 'none' : 'all'
            }} onMouseOver={() => {
                if(props.parameters.highlightOnHover) {
                    setIsOver(true);
                }
			}} onMouseEnter={() => {
				var rollOverAudio = document.getElementById('button-rollover');
				if(!globals.isMuted) {
					(rollOverAudio as any).play();
				}
			}} onMouseDown={() => {
				setIsOver(true);
			}} 
			aria-disabled={props.parameters.isDisabled()}
			onMouseOut={() => {
				setIsOver(false);
			}} onClick={() => {
				if(props.parameters.isDisabled()) {
					return;
				}
				var clickAudio = document.getElementById('button-click');
				if(!globals.isMuted) {
					(clickAudio as any).play();
				}
				if(props.parameters.onClickedd) {
					props.parameters.onClickedd();
				}
			}}>
				<img style={{
					pointerEvents: 'none'
				}} src='./assets/images/general/components/talks-actions/bar_main.png' />
				{isOver || props.parameters.shouldLeaveOn || forceHighlight ? (<img style={{
					position: 'absolute',
					top: '0',
					left: '0',
					width: '100%',
					height: '100%',
					pointerEvents: 'none'
				}} src='./assets/images/general/components/talks-actions/bar_down.png' />) : (<div></div>)}
				{props.parameters.isDisabled() ? (<img style={{
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    width: '100%',
                    height: '100%',
                    pointerEvents: 'none',
					opacity: '0.5',
                }} src='./assets/images/general/components/talks-actions/bar_main.png' />) : (<div></div>)}

				{props.parameters.isDisabled() ? (
					<p style={{
						position: 'absolute',
						margin: '10px',
						top: '10px',
						left: '35px',
						width: '73%',
						fontSize: '25px',
						textAlign: 'left',
						color: 'white',
						opacity: '0.5'
					}}>{props.parameters.text}</p>
				) : (
					<p style={{
						position: 'absolute',
						margin: '10px',
						top: '10px',
						left: '35px',
						width: '73%',
						fontSize: '25px',
						color: 'white',
						textAlign: 'left'
					}}>{props.parameters.text}</p>
				)}

			</button>
		</div>
	);

};

export interface TalksActionsButtonsConfig extends BaseConfig{
    isDisabled?: () => boolean;
	top: string;
	text: string;
	shouldLeaveOn?: boolean;
	highlightOnHover?: boolean;
	onClickedd: () => void;
	onForceHighlight?: (forceHighlight: (shouldForce: boolean) => void) => void;
}

export default TalksActionsButtons;